import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getServicesManager } from '../../../services'
import { VoiceBot } from '../../../interfaces/bot-config'
import { PayloadAction } from '@reduxjs/toolkit'

// Async thunks
export const fetchVoiceBots = createAsyncThunk(
  'voiceBots/fetchVoiceBots',
  async () => {
    const servicesManager = getServicesManager()
    const bots = await servicesManager.getVoiceBots()
    return bots || []
  }
)

// State interface
interface VoiceBotsState {
  bots: VoiceBot[]
  isLoading: boolean
  error: string | null
}

const initialState: VoiceBotsState = {
  bots: [],
  isLoading: false,
  error: null,
}

// Slice
const voiceBotsSlice = createSlice({
  name: 'voiceBots',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    clearBots: (state) => {
      state.bots = []
      state.error = null
    },
    addBot: (state, action: PayloadAction<VoiceBot>) => {
      state.bots.push(action.payload)
    },
    updateBot: (state, action: PayloadAction<VoiceBot>) => {
      const index = state.bots.findIndex(bot => bot.agent_id === action.payload.agent_id)
      if (index !== -1) {
        state.bots[index] = action.payload
      }
    },
    deleteBot: (state, action: PayloadAction<string>) => {
      state.bots = state.bots.filter(bot => bot.agent_id !== action.payload)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVoiceBots.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(fetchVoiceBots.fulfilled, (state, action) => {
        state.isLoading = false
        state.bots = action.payload
      })
      .addCase(fetchVoiceBots.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message || 'Failed to fetch voice bots'
      })
  },
})

export const { clearError, clearBots, addBot, updateBot, deleteBot } = voiceBotsSlice.actions
export default voiceBotsSlice.reducer 